const locales = {
  "nl-nl": {
    poster: "/assets/images/video-posters/body-type-nl-nl.jpg",
    source:
      "https://cdn.api.auping.com/sites/default/files/2022-04/AUPING_bodytypes_NL.mp4",
  },
  "nl-be": {
    poster: "/assets/images/video-posters/body-type-nl-be.jpg",
    source:
      "https://cdn.api.auping.com/sites/default/files/2022-06/AUPING_CUTDOWN_1_VL_S.mp4",
  },
  "fr-be": {
    poster: "/assets/images/video-posters/body-type-fr-be.jpg",
    source:
      "https://cdn.api.auping.com/sites/default/files/2022-05/AUPING_CUTDOWN_bodytypes_small_FR%20(1).mp4",
  },
  "de-de": {
    poster: "/assets/images/video-posters/body-type-de-de.jpg",
    source:
      "https://cdn.api.auping.com/sites/default/files/2022-06/AUPING_CUTDOWN_1_DU_S.mp4",
  },
  default: {
    poster: "/assets/images/video-posters/body-type-nl-nl.jpg",
    source:
      "https://cdn.api.auping.com/sites/default/files/2022-04/AUPING_bodytypes_NL.mp4",
  }
};

export const videoData = {
  "body-type": {
    locales: locales
  },
  "body-type-partner": {
    locales: locales
  }
};
